import script from "./UploadImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadImage.vue?vue&type=script&lang=ts&setup=true"

import "./UploadImage.vue?vue&type=style&index=0&id=bef651e6&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bef651e6"]])

export default __exports__